<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
<div [hidden]="isLoading">
  <div class="alert alert-info pb-0" [innerHTML]="infoAlertContent | escapeHtml"></div>
  <legend>{{ 'tkey;microsoft_360.view.teams.call_forward_settings.forwarding_rules.header' | translate }}</legend>
  <ziro-teams-calling-forwarding-rules-field
    [fieldId]="'forwardingRules'"
    [userPrincipalName]="userPrincipalName"
    [userDisplayName]="userDisplayName"
    [delegates]="getSelectedDelegates()"
    [pickupGroups]="callPickupGroups"
    [tenantId]="tenantId"
  ></ziro-teams-calling-forwarding-rules-field>
  <legend>{{ 'tkey;microsoft_360.view.teams.call_forward_settings.unanswered_rules.header' | translate }}</legend>
  <ziro-teams-calling-unanswered-rules-field
    [fieldId]="'unansweredRules'"
    [userPrincipalName]="userPrincipalName"
    [disabled]="entity?.forwardingRules?.forwardingType === ForwardingType.IMMEDIATE"
    [forwardingTargetType]="entity?.forwardingRules?.forwardingTargetType"
    [delegates]="getSelectedDelegates()"
    [pickupGroups]="callPickupGroups"
    [tenantId]="tenantId"
  ></ziro-teams-calling-unanswered-rules-field>
  <legend>{{ 'tkey;microsoft_360.view.teams.call_forward_settings.delegate_management.header' | translate }}</legend>
  <div class="d-flex justify-content-start">
    <div class="w-100">
      <ziro-select [fieldId]="'searchTerm'"></ziro-select>
    </div>
  </div>
  <div class="row m-3">
    @for (item of selectedDelegates; track item) {
      <div class="col-md-6">
        <ziro-calling-delegate-card-form
          [photoBase64]="item.userPhoto.photoBase64"
          [displayName]="item.userPhoto.displayName"
          [entity]="{
            id: item.userPhoto.userPrincipalName,
            makeCallsEnabled: item.assignedCallingDelegate.makeCallsEnabled,
            manageSettingsEnabled: item.assignedCallingDelegate.manageSettingsEnabled,
            receiveCallsEnabled: item.assignedCallingDelegate.receiveCallsEnabled,
          }"
          [currentUser]="userDisplayName"
          (delegateRemoved)="delegateRemoveClicked($event)"
          (ziroFormsUpdate$)="updateSelectedDelegate($event)"
        ></ziro-calling-delegate-card-form>
      </div>
    }
  </div>
</div>
